import React from 'react';
import { FormattedMessage } from 'react-intl';

class DashboardIntro extends React.Component {
    render() {

        const link_price_list = <a href="/files/misc/20190709_Preisliste_Paulaner_Esta_Druck_GmbH.pdf" target="_blank" download><FormattedMessage id="LABEL_PRICE_LIST" /></a>;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h2 className="panel-title"><FormattedMessage id="LABEL_INTRO_TITLE" /></h2>
                </div>
                <div className="panel-body">
                    <p><FormattedMessage id="TEXT_INTRO_SUMMARY" /></p>
                    <p><FormattedMessage id="TEXT_INTRO_PRODUCT_OVERVIEW" /></p>
                    <ul>
                        <li><FormattedMessage id="LIST_ELEMENT_1_TEXT_INTRO_PRODUCT_OVERVIEW" /></li>
                        <li><FormattedMessage id="LIST_ELEMENT_2_TEXT_INTRO_PRODUCT_OVERVIEW" /></li>
                        <li><FormattedMessage id="LIST_ELEMENT_3_TEXT_INTRO_PRODUCT_OVERVIEW" /></li>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_4_TEXT_INTRO_PRODUCT_OVERVIEW" /></li>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_5_TEXT_INTRO_PRODUCT_OVERVIEW" /></li>
                    </ul>
                    <p><FormattedMessage id="TEXT_INTRO_PRODUCT_OVERVIEW_2" /></p>
                    <br />
                    <p><FormattedMessage id="TEXT_INTRO_START" /></p>
                    <h4><FormattedMessage id="LABEL_INTRO_STEP_1" /></h4>
                    <p><FormattedMessage id="TEXT_INTRO_STEP_1" /></p>
                    <br />
                    <h4><FormattedMessage id="LABEL_INTRO_STEP_2" /></h4>
                    <p><FormattedMessage id="TEXT_INTRO_STEP_2" /></p>
                    <br />
                    <h4><FormattedMessage id="LABEL_INTRO_STEP_3" /></h4>
                    <p><FormattedMessage id="TEXT_INTRO_STEP_3" /></p>
                    <ul>
                        <li><FormattedMessage id="LIST_ELEMENT_1_TEXT_INTRO_STEP_3" /></li>
                        <li><FormattedMessage id="LIST_ELEMENT_2_TEXT_INTRO_STEP_3" /></li>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_3_TEXT_INTRO_STEP_3" /></li>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_4_TEXT_INTRO_STEP_3" /></li>
                    </ul>
                    <br />
                    <h4><FormattedMessage id="LABEL_INTRO_STEP_4" /></h4>
                    <p><FormattedMessage id="TEXT_INTRO_STEP_4" /></p>
                    <br />
                    <h4><FormattedMessage id="LABEL_INTRO_STEP_5" /></h4>
                    <p><FormattedMessage id="TEXT_INTRO_STEP_5" /></p>
                    <ul>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_1_TEXT_INTRO_STEP_5" values={{link_price_list: link_price_list}}/></li>
                        <li className={ 'hide-for-'  + window.plskAppLocale }><FormattedMessage id="LIST_ELEMENT_2_TEXT_INTRO_STEP_5" /></li>
                    </ul>
                    <p><FormattedMessage id="TEXT_2_INTRO_STEP_5" /></p>
                    <p><FormattedMessage id="TEXT_3_INTRO_STEP_5" /></p>
                    <p><FormattedMessage id="TEXT_4_INTRO_STEP_5" /></p>
                </div>
            </div>
        );
    }
}

export default DashboardIntro;




// WEBPACK FOOTER //
// ./src/js/components/DashboardIntro.react.jsx